import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import Reducer from "./Redux/Reducer";
import { createStore } from "redux";
import { Provider } from "react-redux";

const options = {
  position: "top right",
  timeout: 5000,
  offset: "30px",
  transition: "scale",
};
const root = ReactDOM.createRoot(document.getElementById("root"));
const store = createStore(Reducer);
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
